import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import FormInput from '../../components/elements/form_input';
// import Button from '../../components/elements/button';
import { Search, } from '../../assets/icons';
import '../../assets/css/doctor/cases.css';
import { casesApi } from '../../network/apis/cases';

const DoctorCases = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [, setLoading] = useState(true);
        const [cases, setCases] = useState([]);
        const [, setError] = useState(null);
    const [filters, setFilters] = useState({
        status: 'all',
        priority: 'all',
        date: 'all'
    });

    // const [cases] = useState([
    //     {
    //         id: 'CS001',
    //         title: 'Abnormal Fish Behavior',
    //         farm: {
    //             name: 'Atlantic Fish Farm',
    //             location: 'Lagos'
    //         },
    //         reportedDate: '2024-03-15',
    //         status: 'in-progress',
    //         priority: 'high',
    //         symptoms: ['Erratic swimming', 'Loss of appetite'],
    //         lastUpdate: '2 hours ago'
    //     }
    //     // Add more cases
    // ]);

    useEffect(() => {
                fetchCases();
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
            }, []);
        
            const fetchCases = async () => {
                        try {
                            setLoading(true);
                            const response = await casesApi.getCases();
                        
                        // Handle paginated response
                        if (response.data) {
                            setCases(response.data);
                        } else {
                            setCases([]);
                        }
                    } catch (error) {
                        setError(error.message || 'Failed to fetch doctors');
                        setCases([]);
                    } finally {
                        setLoading(false);
                    }
                    };
        

    const filteredCases = cases.filter(caseItem => 
        caseItem.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        caseItem.farm.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="doctor-cases">
            <div className="page-header">
                <div className="header-content">
                    <h1>My Cases</h1>
                    <p>{cases.length} cases assigned</p>
                </div>
            </div>

            <div className="cases-filters">
                <div className="mdc-text-field mdc-text-field--outlined mdc-text-field--with-leading-icon search-field">
                    <span className="mdc-text-field__icon mdc-text-field__icon--leading">
                        <img src={Search} alt="" />
                    </span>
                    <input 
                        type="text"
                        className="mdc-text-field__input"
                        id="search-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <div className="mdc-notched-outline">
                        <div className="mdc-notched-outline__leading"></div>
                        <div className="mdc-notched-outline__notch">
                            <label className={`mdc-floating-label ${searchTerm ? 'mdc-floating-label--float-above' : ''}`}>Search cases...</label>
                        </div>
                        <div className="mdc-notched-outline__trailing"></div>
                    </div>
                    {searchTerm && (
                        <button 
                            className="mdc-icon-button clear-btn"
                            onClick={() => setSearchTerm('')}
                            aria-label="Clear search"
                        >
                            <span className="material-icon">×</span>
                        </button>
                    )}
                </div>

                <div className="filter-chips">
                    <div className="mdc-select mdc-select--outlined">
                        <div className="mdc-select__anchor">
                            <span className="mdc-notched-outline">
                                <span className="mdc-notched-outline__leading"></span>
                                <span className="mdc-notched-outline__notch">
                                    <span className="mdc-floating-label mdc-floating-label--float-above">Status</span>
                                </span>
                                <span className="mdc-notched-outline__trailing"></span>
                            </span>
                            <select 
                                className={`mdc-select__native-control ${filters.status !== 'all' ? 'has-value' : ''}`}
                                value={filters.status}
                                onChange={(e) => setFilters({...filters, status: e.target.value})}
                            >
                                <option value="all">All</option>
                                <option value="new">New</option>
                                <option value="in-progress">In Progress</option>
                                <option value="resolved">Resolved</option>
                            </select>
                            <span className="mdc-select__dropdown-icon">
                                <svg viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z"/></svg>
                            </span>
                        </div>
                    </div>

                    <div className="mdc-select mdc-select--outlined">
                        <div className="mdc-select__anchor">
                            <span className="mdc-notched-outline">
                                <span className="mdc-notched-outline__leading"></span>
                                <span className="mdc-notched-outline__notch">
                                    <span className="mdc-floating-label mdc-floating-label--float-above">Priority</span>
                                </span>
                                <span className="mdc-notched-outline__trailing"></span>
                            </span>
                            <select 
                                className={`mdc-select__native-control ${filters.priority !== 'all' ? 'has-value' : ''}`}
                                value={filters.priority}
                                onChange={(e) => setFilters({...filters, priority: e.target.value})}
                            >
                                <option value="all">All</option>
                                <option value="high">High</option>
                                <option value="medium">Medium</option>
                                <option value="low">Low</option>
                            </select>
                            <span className="mdc-select__dropdown-icon">
                                <svg viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z"/></svg>
                            </span>
                        </div>
                    </div>

                    <div className="mdc-select mdc-select--outlined">
                        <div className="mdc-select__anchor">
                            <span className="mdc-notched-outline">
                                <span className="mdc-notched-outline__leading"></span>
                                <span className="mdc-notched-outline__notch">
                                    <span className="mdc-floating-label mdc-floating-label--float-above">Date</span>
                                </span>
                                <span className="mdc-notched-outline__trailing"></span>
                            </span>
                            <select 
                                className={`mdc-select__native-control ${filters.date !== 'all' ? 'has-value' : ''}`}
                                value={filters.date}
                                onChange={(e) => setFilters({...filters, date: e.target.value})}
                            >
                                <option value="all">All Time</option>
                                <option value="today">Today</option>
                                <option value="week">This Week</option>
                                <option value="month">This Month</option>
                            </select>
                            <span className="mdc-select__dropdown-icon">
                                <svg viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z"/></svg>
                            </span>
                        </div>
                    </div>

                    {(filters.status !== 'all' || filters.priority !== 'all' || filters.date !== 'all') && (
                        <button 
                            className="mdc-button mdc-button--outlined clear-filters-btn"
                            onClick={() => setFilters({ status: 'all', priority: 'all', date: 'all' })}
                        >
                            <span className="mdc-button__ripple"></span>
                            <span className="mdc-button__label">Clear All</span>
                        </button>
                    )}
                </div>
            </div>

            <div className="cases-grid">
                {filteredCases.map(caseItem => (
                    <div 
                        onClick={() => navigate(`/vet/cases/${caseItem.case_code}`, {state:{case:cases.find(c => c.id === caseItem.id)}})}
                        key={caseItem.id} 
                        className={`case-card ${caseItem.priority.toLowerCase()}`}
                    >
                        <div className="case-header">
                            <span className="case-id">{caseItem.case_code}</span>
                            <span className={`status ${caseItem.status.toLowerCase()}`}>
                                {caseItem.status}
                            </span>
                        </div>

                        <h3>{caseItem.title}</h3>
                        
                        <div className="farm-info">
                            {/* <span className="farm-name">{caseItem.farm.name}</span>
                            <span className="farm-location">{caseItem.farm.location}</span> */}
                        </div>

                        <div className="symptoms-list">
                            {caseItem.symptoms.map((symptom, index) => (
                                <span key={index} className="symptom-tag">
                                    {symptom}
                                </span>
                            ))}
                        </div>

                        <div className="case-footer">
                            <span className="date">Reported: {caseItem.created_at}</span>
                            <span className="update">Updated {caseItem.updated_at}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DoctorCases;